
import PercentBox from '@/components/shared/PercentBox';
import { companyLogoHandler } from '@/mixins';
import FormatterService from "@/service/FormatterService";

export default {
    name: 'FinAgentStockDetailsList',

    components: {
        PercentBox,
    },

    mixins: [ companyLogoHandler ],

    props: {
        configurations: {
            type: Array,
            default: () => []
        },
    },

    data() {        
        return {
            isLoading: false,
            stockDetailsData: []
        }
    },

    watch: {
        configurations: {
            immediate: true,
            handler(newConfigurations) {
                this.cancelActiveRequests()
                if (newConfigurations && newConfigurations.length > 0) {
                    this.initStockDetailsData(newConfigurations)
                    this.fetchStocksData(newConfigurations)
                }
            }
        }
    },

    created() {
        this.format = new FormatterService()
    },

    beforeDestroy() {
        this.cancelActiveRequests()
    },

    methods: {
        cancelActiveRequests() {
            if (this.activeQuotesRequest) {
                this.activeQuotesRequest.cancel();
            }
        },

        getStockDetailsPageLink(slug) {
            if (!slug) {
                return '';
            }

            return { name: this.$getTranslatedRouteName('aktie-share'), params: { share: slug } }
        },

        async fetchQuotesData(isins = []) {
            try {
                this.cancelActiveRequests();
                const url = '/api/quotes/current';
                const params = { isins };
                const axiosSource = this.$axios.CancelToken.source();
                const cancelToken = axiosSource.token;
                this.activeQuotesRequest = { cancel: axiosSource.cancel, msg: "Cancel loading quotes..." };
                const res = await this.$axios.get(url, { params, cancelToken });
                const quotesData = res.data;

                this.activeQuotesRequest = null;
                return quotesData;
            } catch (error) {
                if (this.$axios.isCancel(error)) {
                    throw error
                }
                this.activeQuotesRequest = null;
                return null;
            }
        },

        initStockDetailsData(configurations) {
            this.stockDetailsData = [...configurations];
        },

        updateStockDataWithQuotes(quotesMapping = {}) {
            let tempStockDetailsData = [...this.stockDetailsData];
            tempStockDetailsData = tempStockDetailsData.map(s => {
                if (quotesMapping[s.isin]) {
                    return { ...s, ...quotesMapping[s.isin]};
                }

                return s;
            });

            this.stockDetailsData = tempStockDetailsData;
        },

        async fetchStocksData(configurations) {
            try {
                this.isLoading = true;
                const isins = configurations.map(c => c.isin).filter(i => !!i);
                const res = await this.fetchQuotesData(isins);
                this.updateStockDataWithQuotes(res);
                this.isLoading = false;
            } catch (error) {
                if (this.$axios.isCancel(error)) {                    
                    return
                }
                this.isLoading = false
            }
        }
    },  
}
